import { render, staticRenderFns } from "./BookingCopyCreate.vue?vue&type=template&id=066d7f35&scoped=true&"
import script from "./BookingCopyCreate.vue?vue&type=script&lang=js&"
export * from "./BookingCopyCreate.vue?vue&type=script&lang=js&"
import style0 from "./BookingCopyCreate.vue?vue&type=style&index=0&id=066d7f35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d7f35",
  null
  
)

export default component.exports